import React, { useState, useEffect } from "react";
import NavBar from "../components/navbar";
import Banner from "../components/courseBanner";
import Courses from "../components/courses";
import Footer from "../components/footer";
export default function Course({ courseId }) {

    return (
        <div>
            <NavBar/>
            <Banner style={{width:"100%"}}/>
            <Courses/>
            <Footer/>
        </div>
    );
};
